// extracted by mini-css-extract-plugin
module.exports = {"container":"Tabs_container__1HEm_","selector":"Tabs_selector__yS5lf","button-group":"Tabs_button-group__TrliU","button":"Tabs_button__28sN9"};